var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnramp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0438 0.520996H31.7456L12.8035 20.3784H17.8474H23.8507V24.5689H1.99585L26.0438 0.520996Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5694 23.9774L28.0446 27.0858V8.5433L17.1138 19.4868H13.4316L30.5694 1.4848V23.9774Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0813 28.4149V24.923H24.0868V14.0706L26.9385 11.2156V28.4149H2.0813Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0446 8.54331V27.0859L30.5694 23.9775V1.48481L13.4316 19.4869H17.1138L28.0446 8.54331ZM18.677 19.4869H22.9809V15.178L18.677 19.4869ZM24.0869 14.0707V24.9231H2.08135V28.415H26.9386V11.2157L24.0869 14.0707ZM27.4916 29.521H0.975342V24.3701L25.7954 -0.479004H31.6754V24.3701L27.4916 29.521ZM29.8589 0.627006L10.8516 20.5929H22.9809V23.8171H3.09093L26.2539 0.627006H29.8589Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnramp);
export default __webpack_public_path__ + "static/media/onramp.2d67791a.svg";
export { ForwardRef as ReactComponent };